import * as tslib_1 from "tslib";
import { Component, Ref, Vue } from "vue-property-decorator";
import QuestionSearch from '../components/QuestionSearch.vue';
import QuestionTable from '../components/QuestionTable.vue';
import GroupTree from '../components/GroupTree.vue';
import QuestionPreview from "../components/QuestionPreview.vue";
import { addQuestionCategory, deletePaperCategory, getQuestionCategoryList, getQuestionDetail, updateQuestionCategory } from "@/api/question";
import { QUESTION_TYPE_MAP } from "../constant";
const EMPTY_QUESTION = {
    type: 0,
    topic: "",
    audios: [],
    options: [],
    answer: "",
    analysis: "",
    children: []
};
let QuestionBank = class QuestionBank extends Vue {
    constructor() {
        super(...arguments);
        this.questionTypes = QUESTION_TYPE_MAP;
        this.questionLibraryId = '0';
        this.treeData = [];
        this.expandedKeysObj = {
            '': null,
        };
        this.nodeKey = '';
        this.showQuesionPreview = false;
        this.showPreviewLoading = false;
        this.question = JSON.parse(JSON.stringify(EMPTY_QUESTION));
        this.treeNodeMap = null;
        this.showDialog = false;
    }
    created() {
        this.initParams();
        this.$bus.$on('refresh-library-tree', async () => {
            try {
                const treeEl = this.tree;
                if (!treeEl)
                    return;
                this.treeData = await treeEl.refreshTree();
            }
            catch (_) {
            }
        });
    }
    mounted() {
        this.$nextTick(() => {
            this.updateVisibleHeight(),
                window.addEventListener("resize", this.updateVisibleHeight);
        });
    }
    beforeDestroy() {
        window.removeEventListener("resize", this.updateVisibleHeight);
    }
    initParams() {
        // this.$store.commit('setGlobalLoading', true)
        const libraryId = this.$route.params.lib_id;
        if (libraryId) {
            this.questionLibraryId = libraryId;
            localStorage.setItem('questionLibraryId', libraryId);
            sessionStorage.setItem('questionLibraryId', libraryId);
        }
    }
    addQuestion(type) {
        this.$router.push({
            name: type === 6 ? 'MaterialQuestionEdit' : 'QuestionEdit',
            query: {
                type: `${type}`,
                is_edit: '0',
            }
        });
    }
    async fetchPreviewData(id) {
        this.question = JSON.parse(JSON.stringify(EMPTY_QUESTION));
        this.showQuesionPreview = true;
        this.showPreviewLoading = true;
        try {
            const { data } = await getQuestionDetail(id);
            this.preview(data.data);
        }
        catch (_) { }
        finally {
            this.showPreviewLoading = false;
        }
    }
    preview(question) {
        if (void 0 === question)
            this.$message.warning('题目数据格式错误，请检查！');
        const type = question.type;
        if (-1 !== [0, 1, 2, 3, 4, 5].indexOf(type)) {
            this.question = this.handleQuestionData(question);
        }
        else if (6 === type) {
            const subQuestions = question.subQuestionList;
            const children = [];
            const answer = [];
            const analysis = [];
            subQuestions.map((q) => this.handleQuestionData(q))
                .forEach((q) => {
                children.push({
                    topic: q.topic,
                    options: q.options,
                });
                answer.push(q.answer);
                analysis.push(q.analysis);
            });
            this.question = {
                type: type,
                // topic: ve.a.filter(question.content),
                topic: question.content,
                options: [],
                answer: answer,
                analysis: analysis,
                children: children,
            };
        }
    }
    handleQuestionData(question) {
        if (!question) {
            return this.$message.warning('题目数据格式错误，请检查！');
        }
        let options = [];
        if (Array.isArray(question.optionList)) {
            options = question.optionList.map((option, index) => ({
                id: option.id,
                // content: ve.a.filter(e.content),
                content: option.content,
                correct: Number(option.correct),
                orderStr: String.fromCharCode(65 + index)
            }));
        }
        const type = question.type;
        let answer = '';
        if (0 === type || 1 === type || 5 === type) {
            if (options.length > 0) {
                const _answers = options.filter(option => option.correct === 1);
                const length = _answers.length;
                for (let i = 0; i < length; i++) {
                    if (0 !== i && i !== length)
                        answer += '、';
                    answer += _answers[i].orderStr;
                }
            }
        }
        else if (2 === type) {
            // answer = ve.a.filter(question.correct_answer);
            if (options.length > 0) {
                answer = options[0].content;
            }
        }
        else if (3 === type) {
            answer = 1 == question.optionList[0].correct ? '正确' : '错误';
        }
        else if (4 === type) {
            const length = options.length;
            for (let i = 0; i < length; i++) {
                answer += `${0 !== i && i !== length ? '；' : ''}`;
                var _answer = options[i].content.split('；');
                if (_answer.length > 1) {
                    answer += `“${_answer.join('” 或 “')}”`;
                }
                else {
                    answer += _answer[0];
                }
            }
        }
        return {
            type,
            // topic: ve.a.filter(question.content),
            topic: question.content,
            // audios: question.audio_urls,
            options: (0 === type || 1 === type || 5 === type) ? options : [],
            answer,
            // analysis: ve.a.filter(question.analysis),
            analysis: question.analysis
        };
    }
    async handleGetTreeGroup(handler) {
        try {
            const { data } = await getQuestionCategoryList();
            handler(data.data);
        }
        catch (_) { }
    }
    async handleTreeSearch(params, handler) {
        try {
            const { data } = await getQuestionCategoryList(params.keyword);
            handler(data.data);
        }
        catch (_) { }
    }
    async handleTreeAdd(params, handler) {
        try {
            await addQuestionCategory(params);
            this.$message.success('添加分类成功');
            handler();
        }
        catch (_) { }
    }
    async handleTreeUpdate(params, handler) {
        try {
            await updateQuestionCategory(params);
            this.$message.success('重命名成功');
            handler();
        }
        catch (_) { }
    }
    handleTreeChange(treeData) {
        this.treeData = treeData;
    }
    handleTreeNodeClick(nodeData) {
        localStorage.setItem('questionLibraryId', nodeData.id);
        localStorage.setItem('questionPageIndex', '1');
        this.questionLibraryId = nodeData.id;
    }
    updateVisibleHeight() {
        const el = this.mainArea;
        if (el) {
            const document = window.document.documentElement || window.document.body;
            const documentHeifht = document.clientHeight;
            const top = el.getBoundingClientRect().top;
            const offset = 20 + 10 + 1;
            const height = Math.floor(documentHeifht - top - offset);
            el.style.height = `${height}px`;
        }
    }
    async handleDeleteCategory(params, handler) {
        try {
            await deletePaperCategory(params);
            this.$message.success('删除分类成功');
            handler();
        }
        catch (_) { }
    }
    handleDeleteCategoryFail() {
        this.$confirm('该分类内存在题目或下级分类，不可删除', {
            type: 'info',
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '知道了',
        });
    }
    syncTreeNodeMap(nodeMap) {
        this.treeNodeMap = nodeMap;
    }
};
tslib_1.__decorate([
    Ref()
], QuestionBank.prototype, "mainArea", void 0);
tslib_1.__decorate([
    Ref()
], QuestionBank.prototype, "tree", void 0);
QuestionBank = tslib_1.__decorate([
    Component({
        name: 'QuestionBank',
        components: {
            QuestionSearch,
            QuestionTable,
            GroupTree,
            QuestionPreview
        },
        filters: {
            formatQuestionType(id) {
                return QUESTION_TYPE_MAP[id] || '-';
            }
        }
    })
], QuestionBank);
export default QuestionBank;
